import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoginBrand } from '../components/auth/LoginBrand';
import { VerifyingOverlay } from '../components/ui/VerifyingOverlay';
import {
  isSoftPortalEntryPending,
  portalHomePath,
  readPortalChoice,
  softPortalEntryTarget,
} from '../lib/portal';
import { resolveDefaultPortalKind } from '../lib/portalAccess';

export function RootRedirectPage() {
  const { session, accessStatus, loading, authError, portalAccess, refreshProfile, signOut } =
    useAuth();

  // Soft choose→portal must never land on "/" Verifying while the route settles.
  if (session && isSoftPortalEntryPending()) {
    const kind = softPortalEntryTarget() ?? readPortalChoice();
    if (kind) return <Navigate to={portalHomePath(kind)} replace />;
  }

  if (!loading && !session) {
    return <Navigate to="/login" replace />;
  }

  if (accessStatus === 'idle' && authError) {
    return (
      <div className="login-page">
        <div className="login-card">
          <LoginBrand />
          <div className="login-card__body">
            <p className="alert alert-error">{authError}</p>
            <div className="login-page__actions">
              <button type="button" className="btn-primary" onClick={() => void refreshProfile()}>
                Retry
              </button>
              <button type="button" className="btn-secondary" onClick={() => void signOut()}>
                Sign out
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (accessStatus === 'choose_portal') {
    return <Navigate to="/choose-portal" replace />;
  }

  if (accessStatus === 'not_on_allowlist' || accessStatus === 'no_email') {
    return <Navigate to="/not-authorized" replace />;
  }

  if (!loading && accessStatus === 'allowed') {
    const choice =
      readPortalChoice() ?? (portalAccess ? resolveDefaultPortalKind(portalAccess) : null);
    if (choice) {
      return <Navigate to={portalHomePath(choice)} replace />;
    }
    return <Navigate to="/choose-portal" replace />;
  }

  // loading / checking / idle-without-error: keep branded shell + modal
  return (
    <div className="login-page">
      <div className="login-card">
        <LoginBrand />
        <div className="login-card__body">
          <p className="login-card__lead">Sign in with your company Microsoft account</p>
        </div>
      </div>
      <VerifyingOverlay
        message={loading && !session ? 'Loading…' : 'Verifying access…'}
      />
      {authError ? <p className="sr-only">{authError}</p> : null}
    </div>
  );
}
